import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'lib-pill-select-group-item [value]',
    templateUrl: 'form-field-pill-select-group-item.html'
})
export class FormFieldPillSelectGroupItemComponent<T> {

    @Input() value!: T;
    @Input() disabled: boolean = false;
    @Input() isCircle: boolean = false;
    @Input() qaTag: string = "";

    @ViewChild('content', {static: true, read: TemplateRef}) label!: TemplateRef<any>;
}
